import React from "react";

export default function PageLoader({ message = "Loading...", fullScreen = false }) {
  return (
    <div className={`page-loading ${fullScreen ? "full-overlay" : ""}`}>
      <div className="page-loading-spinner" />
      <p className="page-loading-text">{message}</p>
    </div>
  );
}